export default __webpack_public_path__ + "static/media/kalyani.singh.1c224ee6.jpg";